const themeSettings = {
  colorPrimary: '#017acd',
  colorPrimaryLight: '#99caeb',
  colorPrimaryDark: '#017acd',
  focusIndicator: `3px dotted #017acd`,
  colorTextPrimary: '#363942',
  colorNeutral: '#017acd',
  colorNeutralLight: '#abb2c1'
}

// This shouldnt be needed ... but keeping it in for reference for the time being
const legacyTheme = {
  'font-color': 'black',
  'color-base': 'black',
  'color-light': 'white',
  'color-dark': '#017acd',
  'color-bar': '#015c9a',
  'color-medium-border': '#abb2c1',
  'color-bg-lighter': 'rgba(240, 241, 244, 0.5)',
  'color-bg-light': '#f0f1f4',
  'color-visited': '#5aa8de',
  'color-disabled': '#5a5f6c',
  'color-focus': '#99caeb',
  'color-hover': '#99caeb',
  'color-active': '#017acd',

  'max-page-width': '1024px',
  'full-page-padding': '0 12.9%' /* 132px/1024px */,
  'mobile-page-padding': '0 4%',
  'content-padding': '0 6.32%' /* 48px/1024px */,

  'print-heading-bg-color': '#f5f5f5'
}

const theme = require('@healthwise-ui/core/Theme').createTheme(themeSettings)
const defaultTheme = theme

module.exports = {
  defaultTheme: defaultTheme,
  localTheme: defaultTheme,
  theme: defaultTheme,
  legacyTheme: legacyTheme
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/common/theme.js